<template>
  <div v-if="showAlert" :class="$style.alert_container">
    <button :class="$style.close_button" @click="dismiss">
      <svg class="btn__icon btn__icon--right icon icon-chevron-right">
        <use
          xlink:href="../assets/images/brinkshome_icons.svg#icon-circle-x"
        ></use>
      </svg>
    </button>
    <div :class="$style.alert_text">{{ message }} </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      isDismissed: false,
    }
  },
  computed: {
    showAlert() {
      return !this.isDismissed && !!this.message
    },
  },
  methods: {
    dismiss() {
      this.isDismissed = true
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.close_button {
  float: right;
  background-color: transparent;
  border: 0;
  color: $color-text-secondary;
  cursor: pointer;
  font-size: 1em;
}

.close_button:hover {
  color: $color-warning-text;
}

.alert_container {
  border-radius: 0.25em;
  background-color: $color-warning-bg;
  margin: 1em;
  text-align: center;
  padding: 0.5em;
}

.alert_text {
  color: $color-danger-text;
  font-weight: 500;
  padding-right: 2em;
}

.phone_link {
  color: $color-danger-text;
  text-decoration: underline;
  font-weight: bold;
}
</style>
